/** ConfidenceBar — 5px track (paper-3) with a colored fill at width%. */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { colors, radii } from '../theme';

type Props = { width: string; color: string };

export default function ConfidenceBar({ width, color }: Props) {
  return (
    <View style={styles.track}>
      <View style={[styles.fill, { width, backgroundColor: color } as any]} />
    </View>
  );
}

const styles = StyleSheet.create({
  track: { height: 5, borderRadius: radii.full, backgroundColor: colors.paper3, overflow: 'hidden' },
  fill: { height: '100%' },
});
